<template>
  <div>
    <sirui-search
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
    >
    </sirui-search>
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :fixed="item.fixed"
          :visible="item.visible"
          :width="item.width"
          :sortable="item.sortable"
          :field="item.field"
          :formatter="item.formatter"
          :params="item.params"
          :type="item.type"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
  </div>
</template>
<script>
  import API from '@/api/masterData/account';
  import tableMixins from '@/common/mixins/table.js';
  export default {
    name: 'financeAccount',
    mixins: [tableMixins],
    computed: {
      // 搜索栏表格展示字段
      searchColumns() {
        return [
          {
            // 科目代码
            name: this.$t('financeAccount.column.accountCode'),
            prop: 'accountCode',
            type: 'input',
          },
          {
            // 状态
            name: this.$t('financeAccount.column.isAvailable'),
            prop: 'isAvailable',
            type: 'dict',
            dictType: 'financeAccountStatus',
          },
        ];
      },
    },
    data() {
      return {
        exportAction: API.EXPORT_ACCOUNTDETAIL,
        query: {
          accountCode: null,
          isAvailable: null,
        },
        columnListDefault: [
          {
            // 复选框
            type: 'checkbox',
            width: '50',
            fixed: 'left',
          },
          {
            // 科目代码
            field: 'accountCode',
            title: 'financeAccount.column.accountCode',
          },
          {
            // 科目描述
            field: 'accountDesc',
            title: 'financeAccount.column.accountDesc',
          },
          {
            // 状态
            field: 'isAvailable',
            title: 'financeAccount.column.isAvailable',
            dictType: 'financeAccountStatus',
          },
        ],
      };
    },
    mounted() {
      this.getData();
      this.getButtonList();
    },
    methods: {
      // 获取列表数据
      async getData() {
        this.load = true;
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const params = { ...this.query, pageNum, pageSize };
        let res = await this.$axios.post(API.GET_ACCOUNTDETAIL_PAGE, params);
        if (res) {
          this.load = false;
          if (res.data.code === 0) {
            this.tableData = res.data.data.records;
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$alert(res.data.msg);
          }
        }
      },
      // 按钮
      chooseClick(type) {
        if (type === 'add' || type === 'edit') {
          let [name, query] = ['financeAccountAdd', {}];
          if (type == 'edit') {
            if (this.multipleSelection.length != 1) {
              return this.tips('onlyOneSelectData', 'error');
            }
            [name, query] = ['financeAccountEdit', { id: this.multipleSelection[0].id }];
          }
          this.toPath(name, query);
        } else if (type === 'export') {
          // 导出
          this.commonExport();
        } else if (type == 'enable') {
          // 启用
          this.handleUpdateStatus('1');
        } else if (type == 'forbid') {
          // 禁用
          this.handleUpdateStatus('0');
        }
      },
      // 启用/禁用
      handleUpdateStatus(isAvailable) {
        if (this.multipleSelection.length == 0) {
          return this.tips('noSelected', 'error');
        }
        let ids = this.multipleSelection.map((item) => {
          return item.id;
        });
        this.loading.startLoading();
        this.$axios.post(API.UPDATE_STATUS, { isAvailable, ids }).then((res) => {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.$message({ showClose: true, message: res.data.msg, type: 'success' });
            this.$refs.siruiTable.clearSelectRecord();
            this.multipleSelection = [];
            this.getData();
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 列表双击
      dblclickEvent(value) {
        this.toPath('financeAccountDetail', { id: value.row.id });
      },
      // 提示
      tips(info, type) {
        this.$message({
          showClose: true,
          message: this.$t(`financeAccount.message.${info}`),
          type: type,
        });
      },
      // 跳转路径
      toPath(name, query) {
        let path = {
          path: `/masterData/${name}`,
          name: name,
          meta: {
            keepAlive: true,
          },
          query: query,
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
    },
  };
</script>
